/*
 *
 * AuthorizedTab
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 15-May-2025
 */

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  title: (
    <PortalMessage
      id='t.app.disputeUci.filter'
      defaultMessage='Filtri'
    />
  ),
  applyFilters: (
    <PortalMessage
      id='t.app.disputeUci.filter.apply'
      defaultMessage='Applica filtri'
    />
  ),
  resetFilterLabel: (
    <PortalMessage
      id='t.app.disputeUci.filter.reset'
      defaultMessage='Azzera filtri'
    />
  ),
  titleSectionPeriod: (
    <PortalMessage
      id='t.app.disputeUci.filter.period'
      defaultMessage='Periodo'
    />
  ),
  periodHelper: (
    <PortalMessage
      id='t.app.disputeUci.filter.period.helper'
      defaultMessage="Puoi visualizzare lo storico delle dispute fino ad un massimo di <b>13 mesi</b>. Il periodo selezionato fa riferimento alla <b>data di creazione della stessa</b>, che trovi all'interno del dettaglio."
    />
  ),
  datePickerLabelFrom: (
    <PortalMessage
      id='t.app.disputeUci.filter.datePicker.from'
      defaultMessage='Da'
    />
  ),
  datePickerLabelTo: (
    <PortalMessage
      id='t.app.disputeUci.filter.datePicker.to'
      defaultMessage='A'
    />
  ),
  titleSectionGeoArea: (
    <PortalMessage
      id='t.app.disputeUci.filter.geoArea'
      defaultMessage='Area geografica'
    />
  ),
  fieldRegion: (
    <PortalMessage
      id='t.app.disputeUci.filter.field.region'
      defaultMessage='Regione'
    />
  ),
  fieldRegionPlaceholder: (
    <PortalMessage
      id='t.app.disputeUci.filter.field.region.placeholder'
      defaultMessage='Seleziona regione'
    />
  ),
  fieldProvince: (
    <PortalMessage
      id='t.app.disputeUci.filter.field.province'
      defaultMessage='Provincia'
    />
  ),
  fieldProvincePlaceholder: (
    <PortalMessage
      id='t.app.disputeUci.filter.field.province.placeholder'
      defaultMessage='Seleziona provincia'
    />
  ),
  titleSectionData: (
    <PortalMessage
      id='t.app.disputeUci.filter.data'
      defaultMessage='Dati pratica'
    />
  ),
  fieldTerminalId: (
    <PortalMessage
      id='t.app.disputeUci.filter.field.terminalId'
      defaultMessage='Terminal ID (TML)'
    />
  ),
  terminalIdLabel: (
    <PortalMessage
      id='t.app.disputeUci.filter.field.terminalId.label'
      defaultMessage='Terminal ID (TML)'
    />
  ),
  selectTerminalIdPlaceholder: (
    <PortalMessage
      id='t.app.disputeUci.filter.field.terminalId.placeholder'
      defaultMessage='Seleziona terminal ID (TML)'
    />
  ),
  searchbarPlaceholder: (
    <PortalMessage
      id='t.app.disputeUci.filter.field.terminalId.searchbar.placeholder'
      defaultMessage='Cerca terminal ID (TML)'
    />
  ),
  selectAll: (
    <PortalMessage
      id='t.app.disputeUci.filter.field.terminalId.selectAll'
      defaultMessage='Tutti'
    />
  ),
  selectedTerminalId: (selected, total) => (
    <PortalMessage
      id='t.app.disputeUci.filter.field.terminalId.selected'
      defaultMessage='{selected} di {total} terminal ID (TML)'
      values={{
        selected,
        total
      }}
    />
  ),
  resetSelection: (
    <PortalMessage
      id='t.app.disputeUci.filter.field.terminalId.resetSelection'
      defaultMessage='Azzera'
    />
  ),
  noResultsLabel: (
    <PortalMessage
      id='t.app.disputeUci.filter.field.terminalId.noResults'
      defaultMessage='Non sono presenti risultati per la ricerca effettuata.'
    />
  ),
  fieldPracticalStatus: (
    <PortalMessage
      id='t.app.disputeUci.filter.field.practicalStatus'
      defaultMessage='Stato pratica'
    />
  ),
  titleSectionResearch: (
    <PortalMessage
      id='t.app.disputeUci.filter.research'
      defaultMessage='Ricerca pratica'
    />
  ),
  fieldResearchByCode: (
    <PortalMessage
      id='t.app.disputeUci.filter.field.researchByCode'
      defaultMessage='Codice pratica'
    />
  ),
  fieldResearchByOrder: (
    <PortalMessage
      id='t.app.disputeUci.filter.field.researchByOrder'
      defaultMessage='Numero ordine transazione'
    />
  )
}

export default formattedMessage
